import React, { useCallback, useState } from 'react';
import ErrorPage from 'pages/Error';
import { SelectActivityType } from 'components/SelectActivityType';
import { useHistory } from 'react-router-dom';
import routes from 'lib/utils/routes';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAG_KEYS } from 'lib/constants';
import SelectWorkOrderOp from './SelectWorkOrderOp';
import JobList from './JobList';
import JobInfo from './JobInfo';

const steps = {
  JOB_LIST: 0,
  JOB_INFO: 1,
  SELECT_ACTIVITY: 2,
};

const laborTicketSteps = {
  SELECT_WORK_ORDER: 0,
  SELECT_ACTIVITY: 1,
};

const MultiStep = ({
  inSetup,
  controlAction,
  startJob,
  machine,
  workOrderId,
  ...props
}) => {
  const history = useHistory();
  const flags = useFlags();
  const laborTicketEnabled = flags[FLAG_KEYS.LABOR_TICKET_ENABLED];
  const [step, setStep] = useState(steps.JOB_LIST);
  const nextStep = () => {
    return setStep(step + 1);
  };
  const previousStep = () => {
    return setStep(step - 1);
  };
  const handleOnClose = useCallback(() => {
    return history.push(routes.machineIdHomePath(machine.id));
  }, [history, machine]);

  if (laborTicketEnabled) {
    switch (step) {
      case laborTicketSteps.SELECT_WORK_ORDER:
        return (
          <SelectWorkOrderOp
            {...props}
            nextStep={nextStep}
            previousStep={previousStep}
            startJob={startJob}
            handleOnClose={handleOnClose}
          />
        );
      case laborTicketSteps.SELECT_ACTIVITY:
        return (
          <SelectActivityType
            {...props}
            handleOnBack={previousStep}
            handleOnSelect={(activityTypeRef) => {
              startJob({ activityTypeRef, workOrderId });
            }}
            handleOnClose={handleOnClose}
          />
        );
      default:
        return (
          /* Haven't updated translation for this */
          <ErrorPage
            error={new Error('Invalid step while selecting an operation')}
          />
        );
    }
  }

  switch (step) {
    case steps.JOB_LIST:
      return (
        <JobList
          {...props}
          nextStep={nextStep}
          previousStep={previousStep}
          handleOnClose={handleOnClose}
        />
      );
    case steps.JOB_INFO:
      return (
        <JobInfo
          {...props}
          nextStep={nextStep}
          previousStep={previousStep}
          handleOnClose={handleOnClose}
          startJob={startJob}
          workOrderId={workOrderId}
        />
      );
    case steps.SELECT_ACTIVITY:
      return (
        <SelectActivityType
          {...props}
          handleOnBack={previousStep}
          handleOnSelect={(activityTypeRef) => {
            startJob({ activityTypeRef, workOrderId });
          }}
          handleOnClose={handleOnClose}
        />
      );
    default:
      return (
        /* Haven't updated translation for this */
        <ErrorPage
          error={new Error('Invalid step while selecting an operation')}
        />
      );
  }
};

export { MultiStep };
